import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

declare let gtag: Function;

@Injectable({
    providedIn: 'root',
})
export class GoogleAnalyticsService {
    acceptedConsent: boolean = false;
    private subject = new Subject<boolean>();

    constructor() { }

    public setState(state: boolean) {
        this.subject.next(state);
    }

    public getState() {
        return this.subject.asObservable();
    }

    public eventEmitter(eventName: string, eventCategory: string, eventAction: string, eventLabel: string, eventValue: number) {
        gtag('event', eventName, {
            eventCategory,
            eventLabel,
            eventAction,
            eventValue,
        });
    }
}